import Vue from 'vue'
import axios from 'axios'

$(() => {
  if (!$('#admin-cs-tickets_index').length) {
    return
  }

  // form.js-admin-cs-ticket-search配下のradio,checkbox,select,inputの入力内容が変更された場合は、formをsubmitするjquery実装
  $(document).on('change', 'form.js-admin-cs-ticket-search input, form.js-admin-cs-ticket-search select', function() {
    $(this).closest('form').submit();
  });
   
})

$(() => {
  if (!$('#admin-cs-tickets_show').length) {
    return
  }

  // ******************************
  // 
  // コメントフォーム登録
  // 
  // ******************************

  // コメントフォームの textarea を取得
  const $textarea = $("textarea.js-comment-form");
  // フォーカス時：表示行数を増やす（入力しやすくするため）
  $textarea.on("focus", function () {
    $(this).attr("rows", 12);
  });
  // フォーカスが外れた時：
  // もし未入力なら、行数を初期値の2に戻す（省スペース）
  $textarea.on("blur", function () {
    if ($(this).val().trim() === "") {
      $(this).attr("rows", 2);
    }
    // 入力済みなら行数はそのまま維持（視認性確保）
  });

  // コメントフォームエリア
  const $commentFormWrapper = $('.js-comment-form-wrapper')
  // 管理者専用表示のチェックボックス
  const $checkbox = $(".js-ticket-form-viewable-only-admin");
  // 送信ボタン
  const $submitButton = $(".js-ticket-form-submit");
  // 初期状態でボタンの文言を設定
  updateSubmitLabel($checkbox.prop("checked"));
  // チェックボックスの状態が変化したときにラベルを更新
  $checkbox.on("change", function () {
    const isChecked = $(this).prop("checked");
    updateSubmitLabel(isChecked);
  });
  // ボタンのラベルを更新する関数
  function updateSubmitLabel(isChecked) {
    if (isChecked) {
      $submitButton.text("保存（非公開）");
      $commentFormWrapper.css('background', '#fef1e1');
    } else {
      $submitButton.text("メール送信");
      $commentFormWrapper.css('background', '#ffffff');
    }
  }



  // ******************************
  // 
  // コメントフォーム編集
  // 
  // ******************************
  $('.js-edit-link').on('click', function (e) {
    e.preventDefault();
    const $comment = $(this).closest('.js-cs-ticket-comment');

    $comment.find('.js-comment-view').hide();
    $comment.find('.js-comment-edit-form').show();
  });

  $('.js-cancel-button').on('click', function () {
    const $comment = $(this).closest('.js-cs-ticket-comment');

    $comment.find('.js-comment-edit-form').hide();
    $comment.find('.js-comment-view').show();
  });

  // ******************************
  // 
  // コメントにスクロール
  // 
  // ******************************
  // URLパラメータからcomment_idを取得
  const params = new URLSearchParams(window.location.search);
  const commentId = params.get('comment_id');

  if (commentId) {
    const $target = $('#comment-' + commentId);

    if ($target.length > 0) {
      // スクロールしてハイライト（任意）
      $('.js-comment-timeline').animate({
        scrollTop: $target.offset().top - 100 // 任意のオフセット
      }, 500);

      // 一時的に背景色を変えて目立たせる（オプション）
      $target
        .css('background-color', '#fff9d6')
        .delay(2000)
        .queue(function (next) {
          $(this).css('background-color', '');
          next();
        });
    }
  }

  // ******************************
  // 
  // コメントの引用
  // 
  // ******************************
  $('.js-blockquote-link').on('click', function (e) {
    e.preventDefault();

    // 対象コメントブロックを取得
    const $comment = $(this).closest('.js-cs-ticket-comment');

    // コメント本文を取得（テキストとして）
    const rawText = $comment.find('.js-message-content').data('text')

    // 各行に ">" を追加して引用化
    const quotedText = rawText
      .split('\n')
      .map(line => '> ' + line)
      .join('\n');

    // コメントフォームに引用をセット & フォーカス
    const $form = $('.js-comment-form');
    const existing = $form.val();

    // 既存のテキストがあれば追記、なければそのまま
    const finalText = existing ? existing + '\n\n' + quotedText + '\n' : quotedText + '\n';
    $form.val(finalText).focus();
  });
})